// =============================================================================
// Feature Flags
// =============================================================================
// FOCUS_MODE: While the app is being polished for the primary tenant
// (Munja Trans) and is NOT yet sold to other companies, every SaaS-/sales-
// facing surface is hidden AND its routes are blocked.
//
// Affected when ON:
//   • Sidebar entry "Abrechnung" (tenant self-billing) — hidden
//   • Sidebar entry "Erweiterungen" (tenant addon catalog) — hidden
//   • Entire sidebar group "Platform / SUPER" — hidden
//   • Direct URL access to any of the above redirects to "/"
//
// Toggle via /app/frontend/.env  →  REACT_APP_FOCUS_MODE=true|false
// =============================================================================
export const FOCUS_MODE =
  (process.env.REACT_APP_FOCUS_MODE || "false").toLowerCase() === "true";

// Routes that are completely disabled in FOCUS_MODE.
// Used by App.js to short-circuit navigation back to the Dashboard.
export const FOCUS_MODE_BLOCKED_PREFIXES = [
  "/abrechnung",
  "/erweiterungen",
  "/super-admin",
];

export function isRouteBlocked(pathname) {
  if (!FOCUS_MODE) return false;
  return FOCUS_MODE_BLOCKED_PREFIXES.some((p) => pathname.startsWith(p));
}
